export class AccessToken {
    Authorization;
}
export class Authentication {
    email;
    secret;
}
export class EmailOfInterest {
    email;
}
export class UpdateSecret {
    secret;
    newSecret;
}
